import { render, staticRenderFns } from "./usersModel.vue?vue&type=template&id=34a6ed16&lang=pug&"
import script from "./usersModel.vue?vue&type=script&lang=js&"
export * from "./usersModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports